import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import './css/global.css';
import './css/home.css';
import './css/pages.css';

// Main pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Blog from "./pages/Blog";
import Article from "./pages/Article";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";

// Service detail pages
import AfterHoursNocSupport from "./pages/services/AfterHoursNocSupport";
import Angularjs from "./pages/services/Angularjs";
import Cakephp from "./pages/services/Cakephp";
import Laravel from "./pages/services/Laravel";
import CustomCms from "./pages/services/CustomCms";
import CustomPhpSoftwareSolutions from "./pages/services/CustomPhpSoftwareSolutions";
import DigitalMarketing from "./pages/services/DigitalMarketing";
import Drupal from "./pages/services/Drupal";
import Expertise from "./pages/services/Expertise";
import Magento from "./pages/services/Magento";
import ManagedCloudMigrationServices from "./pages/services/ManagedCloudMigrationServices";
import ManagedItServices from "./pages/services/ManagedItServices";
import NetworkMonitoringOutsourcingServices from "./pages/services/NetworkMonitoringOutsourcingServices";
import NocServices from "./pages/services/NocServices";
import Nodejs from "./pages/services/Nodejs";
import OnDemandItSupportServices from "./pages/services/OnDemandItSupportServices";
import ReactJsDevelopment from "./pages/services/ReactJsDevelopment";
import ReactNative from "./pages/services/ReactNative";
import Seo from "./pages/services/Seo";
import ServerAndNetworkingAdministration from "./pages/services/ServerAndNetworkingAdministration";
import Shopify from "./pages/services/Shopify";
import SocialMedia from "./pages/services/SocialMedia";
import VirtualizationSolutions from "./pages/services/VirtualizationSolutions";
import VsaServices from "./pages/services/VsaServices";
import WebsiteDesignAndDevelopment from "./pages/services/WebsiteDesignAndDevelopment";
import WebsiteMonitoringAndMaintenance from "./pages/services/WebsiteMonitoringAndMaintenance";
import WoocommerceDevelopment from "./pages/services/WoocommerceDevelopment";
import WordpressDevelopment from "./pages/services/WordpressDevelopment";

import NotFound from './pages/NotFound';
import ProjectModal from './components/global/ProjectModal';
import { useModal } from './context/ModalContext';

function App() {
  return (
    <Router>
      <ScrollToTopWrapper />
    </Router>
  );
}

function ScrollToTopWrapper() {
  const location = useLocation();
  const { modalOpen, closeModal } = useModal();

  useEffect(() => {
    if (location.hash) return;

    if (typeof window.scrollTo === "function") {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
    }
  }, [location.pathname]);

  return (
    <>
      <ProjectModal open={modalOpen} onClose={closeModal} />
      <Routes>
          {/* Main pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Article />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* Service detail pages */}
          <Route path="/after-hours-noc-support" element={<AfterHoursNocSupport />} />
          <Route path="/angularjs" element={<Angularjs />} />
          <Route path="/cakephp" element={<Cakephp />} />
          <Route path="/laravel" element={<Laravel />} />
          <Route path="/custom-cms" element={<CustomCms />} />
          <Route path="/custom-php-software-solutions" element={<CustomPhpSoftwareSolutions />} />
          <Route path="/digital-marketing-services" element={<DigitalMarketing />} />
          <Route path="/drupal" element={<Drupal />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/magento" element={<Magento />} />
          <Route path="/managed-cloud-migration-services" element={<ManagedCloudMigrationServices />} />
          <Route path="/managed-it-services" element={<ManagedItServices />} />
          <Route path="/network-monitoring-outsourcing-services" element={<NetworkMonitoringOutsourcingServices />} />
          <Route path="/noc-services" element={<NocServices />} />
          <Route path="/nodejs" element={<Nodejs />} />
          <Route path="/on-demand-it-support-services" element={<OnDemandItSupportServices />} />
          <Route path="/react-js-development" element={<ReactJsDevelopment />} />
          <Route path="/react-native" element={<ReactNative />} />
          <Route path="/seo" element={<Seo />} />
          <Route path="/server-and-networking-administration" element={<ServerAndNetworkingAdministration />} />
          <Route path="/shopify" element={<Shopify />} />
          <Route path="/social-media" element={<SocialMedia />} />
          <Route path="/virtualization-solutions" element={<VirtualizationSolutions />} />
          <Route path="/vsa-services" element={<VsaServices />} />
          <Route path="/website-design-&-development" element={<WebsiteDesignAndDevelopment />} />
          <Route path="/website-monitoring-and-maintenance" element={<WebsiteMonitoringAndMaintenance />} />
          <Route path="/woocommerce-development" element={<WoocommerceDevelopment />} />
          <Route path="/wordpress-development" element={<WordpressDevelopment />} />

        <Route path="/*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
